import { SiteIdValidRegExp } from '../../settings/controllers/SiteSettingsForServerAdminFormCtrl';
import { Module } from '../Module';

Module.instance().directive('tbSiteIdInputValidator',
  () => {
    return {
      restrict: 'A',
      require: 'ngModel',
       link: (scope: ng.IScope, elm: JQuery, attrs: ng.IAttributes, ctrl: ng.INgModelController) => {

        ctrl.$parsers.push((inputId: any) => {
          ctrl.$setValidity('siteId', SiteIdValidRegExp.InvalidTest.test(inputId));
          return inputId;
        });
      }
    };
  }
);
